import { render, staticRenderFns } from "./login_footer_card.vue?vue&type=template&id=67c8fdf5&scoped=true"
import script from "./login_footer_card.vue?vue&type=script&lang=js"
export * from "./login_footer_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8fdf5",
  null
  
)

export default component.exports